import { waLink } from "../../lib/arvi";

const TIERS = [
  // {
  //   id: "simple",
  //   tier: "Simple Elegance",
  //   price: "₹18,000 – ₹30,000",
  //   time: "1–2 weeks",
  //   points: [
  //     "Minimalist motifs, clean borders",
  //     "Pure silk or blended base",
  //     "One-of-one hand-painted finish",
  //   ],
  // },
  {
    id: "custom",
    tier: "Custom Narrative",
    price: "₹25,000 – ₹50,000",
    time: "3–4 weeks",
    points: [
      "Bespoke design conceptualisation",
      "Heavier border work & detailed motifs",
      "Personal colour palette consultation",
    ],
    highlight: true,
  },
  {
    id: "bridal",
    tier: "The Bridal Canvas",
    price: "₹80,000+",
    time: "2–3 months",
    points: [
      "Intricate full-body artistry",
      "Gold-accented hand-painted detailing",
      "Months of dedicated studio time",
    ],
  },
];

export default function Pricing() {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="bg-parchment py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="max-w-3xl reveal">
          <p className="text-overline text-gold mb-5">Investment in Art</p>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
            Pricing that respects
            <br />
            <span className="italic">the hand behind it.</span>
          </h2>
          <p className="mt-6 text-maroon/70 text-[15px] md:text-base leading-relaxed max-w-xl">
            Every ARVI piece is painted by hand, slowly. The starting
            ranges below depend on motif complexity, fabric and the time
            devoted to each commission.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {TIERS.map((t) => (
            <div
              key={t.id}
              data-testid={`pricing-card-${t.id}`}
              className={`relative flex flex-col border p-8 md:p-10 reveal ${
                t.highlight
                  ? "bg-maroon text-ivory border-maroon"
                  : "bg-ivory text-maroon border-[hsl(var(--gold)/0.5)]"
              }`}
            >
              {t.highlight && (
                <span className="absolute top-0 left-0 -translate-y-1/2 px-3 py-1 bg-gold text-maroon text-[10px] tracking-luxury uppercase">
                  Most Commissioned
                </span>
              )}
              <p className={`text-overline ${t.highlight ? "text-[hsl(var(--gold-soft))]" : "text-gold"}`}>
                {t.tier}
              </p>
              <p className="mt-6 font-display text-3xl md:text-[2rem] leading-tight">
                {t.price}
              </p>
              <p className={`mt-2 text-[13px] ${t.highlight ? "text-ivory/70" : "text-maroon/60"}`}>
                Crafting time · {t.time}
              </p>

              <ul className={`mt-8 space-y-4 text-[14px] leading-relaxed ${t.highlight ? "text-ivory/85" : "text-maroon/80"}`}>
                {t.points.map((p, i) => (
                  <li key={i} className="flex gap-3">
                    <span className={`mt-2 h-px w-4 shrink-0 ${t.highlight ? "bg-[hsl(var(--gold-soft))]" : "bg-gold"}`} />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>

              <a
                href={waLink(`Hello ARVI, I'd like to enquire about the ${t.tier} tier.`)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`pricing-cta-${t.id}`}
                className={`mt-10 btn-cta-base ${
                  t.highlight ? "btn-wa-on-dark bg-gold text-maroon" : "btn-wa"
                }`}
              >
                Enquire on WhatsApp
              </a>
            </div>
          ))}
        </div>

        <p className="mt-12 text-center text-[13px] text-maroon/60 italic">
          Final pricing depends on design complexity, fabric and the story you'd like woven in.
        </p>
      </div>
    </section>
  );
}
